<template>
  <div class="container_view">
    <v-card class="content_card" elevation="10" variant="flat">
      <div>
        <header>
          <v-card-title> Grupos </v-card-title>
          <v-divider class="mx-3"></v-divider>
        </header>
      </div>
      <div class="content_accion">
        <div>
          <v-text-field
            v-model="search"
            label="Búsqueda"
            prepend-inner-icon="mdi-magnify"
            single-line
            variant="outlined"
            hide-details
            class="filter"
          ></v-text-field>
        </div>
        <div>
          <v-btn
            icon="mdi-reload"
            size="small"
            variant="outlined"
            color="indigo-darken-3"
            class="mr-2 reload"
            v-on:click="getGroups()"
          >
          </v-btn>
          <v-btn
            v-if="permission.addGrupo"
            v-bind="props"
            class="text-none mb-4"
            @click="openDialog"
            prepend-icon="mdi-plus"
            color="indigo-darken-3"
          >
            Registrar
          </v-btn>
        </div>
      </div>
      <div class="container_table">
        <v-data-table
          class="content_table"
          :headers="headersTable"
          fixed-header
          :items="listGroups"
          :search="search"
          :loading="loading"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <tr>
              <td>
                <div class="actions" v-if="permission.consultarUsuarioGrupo">
                  <v-tooltip activator="parent" location="top"
                    >Gestionar</v-tooltip
                  >
                  <v-btn
                    class="edit"
                    icon="mdi-wrench"
                    color="indigo-darken-3"
                    @click="openDialogGestionar('gestionar', item)"
                  >
                  </v-btn>
                </div>
                <div class="actions" v-if="permission.eliminarGrupo">
                  <v-tooltip activator="parent" location="top"
                    >Eliminar</v-tooltip
                  >
                  <v-btn
                    class="edit"
                    icon="mdi-delete"
                    color="error"
                    @click="openDilogReasignar(item)"
                  ></v-btn>
                </div>
                <div class="actions">
                  <v-tooltip activator="parent" location="top"
                    >Editar</v-tooltip
                  >
                  <v-btn
                    class="edit"
                    icon="mdi-pencil"
                    color="indigo-darken-3"
                    @click="openDialog('edit', item)"
                  ></v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <AlertComponent :value="dialogData" />
    <SnackbarComponent :value="snackbarData" />
  </div>

  <!-- Dialog de registro de grupos-->
  <template>
    <v-dialog width="650" v-model="showDialog">
      <v-card :title="tituloRegistroEdit">
        <v-divider class="mx-3"></v-divider>
        <v-card-text>
          <v-container>
            <v-row v-if="!isLoading">
              <v-col cols="12">
                <label>Nombre</label>
                <v-text-field id="name" v-model="name" required></v-text-field>
              </v-col>
              <v-col cols="12">
                <label>Descripción</label>
                <v-textarea required v-model="description"></v-textarea>
              </v-col>
              <v-col cols="12">
                <label>Responsable</label>
                <v-select
                  :items="listSupervisor"
                  item-title="nameComplete"
                  item-value="id"
                  v-model="selectSupervisor"
                  required
                ></v-select>
              </v-col>
            </v-row>
            <div class="content_load" v-if="isLoading">
              <v-progress-circular
                :size="100"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <i>Espere un momento</i>
            </div>
          </v-container>
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            @click="closeDialog"
          ></v-btn>
          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Guardar"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            :loading="isLoading"
            @click="validateInputs()"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <!--Dialog de gestionar-->
  <template>
    <v-dialog persistent width="1024" v-model="showDialogG">
      <v-card>
        <v-card-title>
          <span class="text-h5">Gestionar {{ titleGestionar }}</span>
        </v-card-title>
        <v-divider class="mx-3"></v-divider>
        <v-card-text>
          <div class="content_accion">
            <div>
              <v-text-field
                v-model="searchGestion"
                label="Buscar..."
                prepend-inner-icon="mdi-magnify"
                single-line
                variant="outlined"
                hide-details
                class="filter"
              ></v-text-field>
            </div>
            <!--hola Agregar usuarios -->
            <div>
              <v-btn
                v-bind="props"
                v-if="permission.asignarUsuariosGrupo"
                class="text-none mb-4"
                @click="openDialogAdd"
                prepend-icon="mdi-plus"
                color="indigo-darken-3"
              >
                Agregar Usuarios
              </v-btn>
            </div>
            <!--adios-->
          </div>
          <div class="container_table">
            <v-data-table
              class="content_table"
              :headers="headersGestion"
              fixed-header
              :items="listUsers"
              :search="searchGestion"
              :loading="loadingGestion"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <tr>
                  <td>
                    <div class="actions" v-if="permission.eliminarMiembro">
                      <v-tooltip activator="parent" location="top"
                        >Eliminar</v-tooltip
                      >
                      <v-btn
                        class="edit"
                        icon="mdi-delete"
                        color="error"
                        @click="openDialogGestionar('eliminar', item)"
                      ></v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            @click="closeDialogGestionar()"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <!--Dialog de eliminacion-->
  <template>
    <v-dialog v-model="dialogDelete" width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Confirmación</span>
        </v-card-title>
        <v-card-text>
          <div v-if="!isLoadingEliminar">
            <div class="text-center">
              <img src="@/assets/images/warning.png" />
            </div>
            <div class="description-text">
              <p>¿Está seguro de eliminar el usuario?</p>
            </div>
          </div>
          <div class="content_load" v-if="isLoadingEliminar">
            <v-progress-circular
              :size="100"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <i>Espere un momento</i>
          </div>
        </v-card-text>
        <v-card-actions class="actions-buttons">
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogDelete = false"
            variant="flat"
            class="text-none mb-4"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            >Cerrar</v-btn
          >
          <v-btn
            :loading="isLoadingEliminar"
            @click="eliminar"
            variant="flat"
            class="text-none mb-4"
            text="Guardar"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <!-- Dialog de agregar mas miembros-->
  <template>
    <v-dialog persistent width="1024" v-model="showDialogAddUsers">
      <v-card title="Agregar Usuario (s)">
        <v-divider class="mx-3"></v-divider>
        <v-card-text v-if="!isLoading">
          <div class="content_accion">
            <div>
              <v-text-field
                v-model="searchAdd"
                label="Buscar..."
                prepend-inner-icon="mdi-magnify"
                single-line
                variant="outlined"
                hide-details
                class="filter"
              ></v-text-field>
            </div>
            <div>
              <v-btn
                variant="flat"
                class="text-none mb-4 selectAll"
                text="Seleccionar todos"
                color="indigo-darken-3"
                prepend-icon="mdi-content-save"
                @click="selectedAll"
              ></v-btn>
              <v-btn
                variant="flat"
                class="text-none mb-4 selectAll"
                text="Deseleccionar todos"
                color="indigo-darken-3"
                prepend-icon="mdi-close"
                @click="diselectedAll()"
              ></v-btn>
              <v-btn
                variant="flat"
                class="text-none mb-4"
                text="Agregar"
                color="indigo-darken-3"
                prepend-icon="mdi-content-save"
                :disabled="validateForm() || isLoading"
                @click="addUsersGroup()"
              ></v-btn>
            </div>
          </div>
          <div class="container_table">
            <v-data-table
              class="content_table"
              :headers="headersAddUser"
              fixed-header
              :items="listUsersFree"
              :search="searchAdd"
              :loading="loadingAdd"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <tr>
                  <td>
                    <div class="actions">
                      <v-checkbox
                        :id="'checked_' + item.id"
                        v-model="checked[item.id]"
                        @change="handleCheckboxChange(item.id)"
                      ></v-checkbox>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            variant="flat"
            class="text-none mb-4 close"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            @click="closeDialogAdd"
          ></v-btn>
        </v-card-actions>
        <div class="content_load" v-if="isLoading">
          <v-progress-circular
            :size="100"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
          <i>Espere un momento</i>
        </div>
      </v-card>
    </v-dialog>
  </template>

  <!-- Dialog de reasignar usuarios-->
  <template>
    <v-dialog width="500" v-model="showDialogEliminar">
      <v-card title="Reasignar Usuarios">
        <v-divider class="mx-3"></v-divider>
        <v-card-text>
          <v-container>
            <div class="py-2" v-if="!isLoadingEliminarGrupo">
              <span
                >Seleccione un grupo para que se puedan asignar los integrantes
                a otro grupo</span
              >
              <v-col cols="12">
                <label>Grupo</label>
                <v-select
                  :items="listGruposEliminar"
                  item-title="nombre"
                  item-value="id_grupo"
                  v-model="grupoSelect"
                  required
                ></v-select>
              </v-col>
            </div>
            <div class="content_load" v-if="isLoadingEliminarGrupo">
              <v-progress-circular
                :size="100"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <i>Espere un momento</i>
            </div>
          </v-container>
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            @click="closeDialogEliminar"
          ></v-btn>

          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Guardar"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            :loading="isLoadingEliminarGrupo"
            @click="reasignar()"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
</template>

<script>
import { GroupService } from "@/services/GroupService";
import AlertComponent from "@/components/Alert.vue";
import SnackbarComponent from "@/components/Snackbar.vue";

export default {
  name: "GroupsComponent",
  components: {
    AlertComponent,
    SnackbarComponent,
  },
  data() {
    return {
      listGroups: [],
      dialogData: {
        openDialog: false,
        title: "",
        description: "",
        icon: "",
      },
      search: "",
      loading: true,
      loadingGestion: true,
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
      showDialog: false,
      showDialogG: false,
      showDialogAddUsers: false,
      showDialogEliminar: false,
      mode: "register",
      headersTable: [
        { title: "No.", key: "number" },
        { title: "Nombre", key: "nombre" },
        { title: "Descripción", key: "descripcion" },
        { title: "Supervisor", key: "username" },
        { title: "Acciones", key: "actions" },
      ],
      headersGestion: [
        { title: "No.", key: "number" },
        { title: "Nombre (s)", key: "name" },
        { title: "Apellidos", key: "last_name" },
        { title: "Eliminar", key: "actions" },
      ],
      headersAddUser: [
        { title: "No.", key: "number" },
        { title: "Nombre (s)", key: "name" },
        { title: "Apellidos", key: "last_name" },
        { title: "Seleccionar", key: "actions" },
      ],
      name: "",
      description: "",
      idGrupo: "",
      searchGestion: "",
      listUsers: [],
      dialogDelete: false,
      idGEliminar: "",
      idUEliminar: "",
      listUsersFree: [],
      searchAdd: "",
      loadingAdd: true,
      grupoSelect: null,
      groupsList: [],
      idGrupEliminar: "",
      checked: {},
      selectedItems: [],
      idGrupoGlobal: "",
      isLoading: false,
      isLoadingEliminar: false,
      isLoadingEliminarGrupo: false,
      listSupervisor: [],
      selectSupervisor: null,
      listGruposEliminar: [],
      permission: {
        addGrupo: false, //M07F01REGR
        asignarUsuariosGrupo: false, //M07F02AUGR
        eliminarGrupo: false, //M07F03ELGR
        eliminarMiembro: false, //M07F03ELMI
        consultarGrupo: false, //M07F03COGR
        consultarUsuarioLibre: false, //M07F03COUL
        consultarUsuarioGrupo: false, //M07F03COUG
      },
      titleGestionar: '',
      tituloRegistroEdit:'Crear Grupos',
    };
  },
  beforeMount() {
    this.getGroups();
  },
  async created() {
    const ENC_PERMISOS = localStorage.getItem("PERMISOS");
    const STR_PERMISOS = atob(ENC_PERMISOS);
    const ARR_PERMISOS = JSON.parse(STR_PERMISOS);
    const PERMISSION = ARR_PERMISOS.find(
      (permission) => permission.modulo === "M07GRUP"
    );
    for (const element of PERMISSION.endpoints) {
      if (element.nombre === "M07F01REGR" && element.permiso === true) {
        this.permission.addGrupo = true;
      }
      if (element.nombre === "M07F02AUGR" && element.permiso === true) {
        this.permission.asignarUsuariosGrupo = true;
      }
      if (element.nombre === "M07F03ELGR" && element.permiso === true) {
        this.permission.eliminarGrupo = true;
      }
      if (element.nombre === "M07F03ELMI" && element.permiso === true) {
        this.permission.eliminarMiembro = true;
      }
      if (element.nombre === "M07F03COGR" && element.permiso === true) {
        this.permission.consultarGrupo = true;
      }
      if (element.nombre === "M07F03COUL" && element.permiso === true) {
        this.permission.consultarUsuarioLibre = true;
      }
      if (element.nombre === "M07F03COUG" && element.permiso === true) {
        this.permission.consultarUsuarioGrupo = true;
      }
    }
  },
  methods: {
    getGroups: async function () {
      this.loading = true;
      await GroupService.getGroupByProfile(localStorage.getItem("TIPO"), null)
        .then((resp) => {
          if (!resp.error) {
            this.listGroups = resp.response;
            let i = 1;
            this.listGroups.forEach((element) => {
              element.number = i;
              i++;
            });

            setTimeout(() => {
              this.loading = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });
    },
    validateInputs() {
      const regexSoloLetras = /^[a-zA-Z0-9_ ]+$/;
      if (this.name == "") {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "El nombre es requerido",
        };
        return false;
      } else if (this.name !== "") {
        let validarTxt = regexSoloLetras.test(this.name);
        if (!validarTxt) {
          this.dialogData = {
            openDialog: true,
            title: "Error",
            description: "No se aceptan caracteres especiales",
          };
          return false;
        }
      }

      if (this.description == "") {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "La descripción es requerida",
        };
        return false;
      } else if (this.description.length > 100) {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "Solo se aceptan 100 caracteres",
        };
        return false;
      }

      this.isLoading = true;
      if (this.mode === "register") {
        this.saveGroup();
      } else {
        this.editGroup();
      }
    },
    openDialog(tipo, data) {
      if (tipo == "edit") {
        this.tituloRegistroEdit = 'Editar Grupos'
        this.mode = "edit";
        this.name = data.nombre;
        this.description = data.descripcion;
        this.idGrupo = data.id_grupo;
        this.selectSupervisor = data.supervisor;
      }
      this.showDialog = true;
      this.getSupervisores();
    },
    closeDialog() {
      this.showDialog = false;
      this.name = "";
      this.description = "";
      this.selectSupervisor = null;
    },
    saveGroup: async function () {
      let idSup = await GroupService.encriptar(this.selectSupervisor);
      const dataForm = new FormData();
      dataForm.append("nombre", this.name);
      dataForm.append("descripcion", this.description);
      dataForm.append("supervisor", idSup.msg);
      dataForm.append("nombre_despacho", localStorage.getItem("DESPACHO"));

      await GroupService.saveGroup(dataForm)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "El grupo se registro exitosamente!",
            };

            this.getGroups();
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });
      this.isLoading = false;
      this.name = "";
      this.description = "";
      this.selectSupervisor = null;
      this.mode = "register";
      this.closeDialog();
    },
    editGroup: async function () {
      let idGrupoEncriptado = await GroupService.encriptar(this.idGrupo);
      let idSup = await GroupService.encriptar(this.selectSupervisor);
      const dataForm = new FormData();
      dataForm.append("nombre", this.name);
      dataForm.append("descripcion", this.description);
      dataForm.append("supervisor", idSup.msg);
      await GroupService.edit(idGrupoEncriptado.msg, dataForm)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "El grupo se edito exitosamente!",
            };

            this.getGroups();
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });

      this.isLoading = false;
      this.name = "";
      this.description = "";
      this.selectSupervisor = null;
      this.mode = "register";
      this.closeDialog();
    },
    openDialogGestionar(tipo, data) {
      if (tipo == "eliminar") {
        this.idUEliminar = data.id;
        this.dialogDelete = true;
      }

      if (tipo == "gestionar") {
        this.idGrupoGlobal = data.id_grupo;
        this.titleGestionar = data.nombre
        this.showDialogG = true;
        this.loadingGestion = true;
        this.getUsersByGruops(data.id_grupo);
      }
    },
    closeDialogGestionar() {
      this.showDialogG = false;
      this.mode = "register";
    },
    getUsersByGruops: async function (idGrupo) {
      this.idGEliminar = idGrupo;
      let idGEncriptado = await GroupService.encriptar(idGrupo);
      await GroupService.getUsersByGroups(idGEncriptado.msg)
        .then((resp) => {
          if (!resp.error) {
            this.listUsers = resp.response;
            let i = 1;
            this.listUsers.forEach((element) => {
              element.number = i;
              i++;
            });

            setTimeout(() => {
              this.loadingGestion = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });
    },
    eliminar: async function () {
      this.isLoadingEliminar = true;
      let idGEnc = await GroupService.encriptar(this.idGEliminar);
      let idUserEnc = await GroupService.encriptar(this.idUEliminar);

      await GroupService.deleteUserByGroup(idUserEnc.msg, idGEnc.msg)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "El usuario se eliminó exitosamente!",
            };

            this.getUsersByGruops(this.idGrupoGlobal);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error
          };
        });
      this.isLoadingEliminar = false;
      this.dialogDelete = false;
    },
    openDialogAdd() {
      this.showDialogAddUsers = true;
      this.getUsersFree();
    },
    closeDialogAdd(tipo) {
      if (tipo == "all") {
        this.selectedAll();
      }
      this.showDialogAddUsers = false;
    },
    getUsersFree: async function () {
      await GroupService.getUserFree(localStorage.getItem("DESPACHO"))
        .then((resp) => {
          if (!resp.error) {
            this.listUsersFree = resp.response;
            let i = 1;
            this.listUsersFree.forEach((element) => {
              element.number = i;
              i++;
            });
            setTimeout(() => {
              this.loadingAdd = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });
    },
    selectedAll() {
      this.listUsersFree.forEach((user) => {
        this.checked[user.id] = true;
        this.handleCheckboxChange(user.id);
      });
    },
    diselectedAll() {
      this.listUsersFree.forEach((user) => {
        this.checked[user.id] = false;
        this.handleCheckboxChange(user.id);
      });
    },
    addUsersGroup: async function () {
      this.isLoading = true;

      const arreglo = await this.encriptarTodos(this.selectedItems);

      let idgenc = await GroupService.encriptar(this.idGrupoGlobal);
      const formData = new FormData();
      formData.append("id_grupo", idgenc.msg);
      formData.append("usuarios", JSON.stringify(arreglo));

      await GroupService.addNewsUsers(formData)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "Se asignaron los usuarios al grupo exitosamente!",
            };
            this.getUsersByGruops(this.idGrupoGlobal);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });

      this.isLoading = false;
      this.selectedItems = [];
      this.checked = {};
      this.closeDialogAdd();
    },
    openDilogReasignar: async function (item) {
      this.showDialogEliminar = true;
      let idGrupoAEliminar = item.id_grupo;
      this.idGrupEliminar = idGrupoAEliminar;

      let idE = await GroupService.encriptar(idGrupoAEliminar);

      await GroupService.getListGroups(
        idE.msg,
        localStorage.getItem("DESPACHO")
      )
        .then((resp) => {
          if (!resp.error) {
            this.listGruposEliminar = resp.response;
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });
    },
    closeDialogEliminar() {
      this.showDialogEliminar = false;
    },
    reasignar: async function () {
      if (this.grupoSelect === null) {
        this.dialogData = {
          openDialog: true,
          title: "Ocurrió un Problema",
          description: "Debe de seleccionar un grupo",
        };
        return false;
      }
      this.isLoadingEliminarGrupo = true;
      let respIdGE = await GroupService.encriptar(this.idGrupEliminar);
      let respGN = await GroupService.encriptar(this.grupoSelect);

      await GroupService.reasignarGroup(respIdGE.msg, respGN.msg)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "El grupo se eliminó exitosamente!",
            };

            this.getGroups();
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });

      this.isLoadingEliminarGrupo = false;
      this.grupoSelect = null;
      this.closeDialogEliminar();
    },
    handleCheckboxChange(itemId) {
      if (this.checked[itemId]) {
        this.selectedItems.push(itemId);
      } else {
        this.selectedItems = this.selectedItems.filter((id) => id !== itemId);
      }
    },
    validateForm() {
      const validate = this.selectedItems.length === 0;
      return validate;
    },
    getSupervisores: async function () {
      await GroupService.getSupervisor(localStorage.getItem("DESPACHO"))
        .then((resp) => {
          if (!resp.error) {
            this.listSupervisor = resp.response;
            this.listSupervisor.forEach((element) => {
              element.nameComplete = element.name + " " + element.last_name;
            });
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });
    },
    encriptarTodos: async function (arrUSers) {
      const dataUsers = new FormData();
      dataUsers.append("usuarios", JSON.stringify(arrUSers));

      try {
        const resp = await GroupService.encriparTodos(dataUsers);
        if (!resp.error) {
          return resp.response; // Devuelve el arreglo si no hay error
        } else {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema 0007",
            description: resp.msg,
          };
          return []; // Devuelve un arreglo vacío en caso de error
        }
      } catch (error) {
        this.dialogData = {
          openDialog: true,
          title: "Ocurrió un Problema",
          description: error,
        };
        return []; // Devuelve un arreglo vacío si ocurre un error
      }
    },
  },
};
</script>

<style scoped>
.filter {
  width: 300px;
}

.content_table {
  overflow: auto;
}

.content_accion {
  padding-bottom: 10px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.actions {
  display: flex;
  align-items: center;
  float: left;
  margin-right: 1vh;
  width: 9vh !important;
  height: 9vh !important;
}
.close {
  margin-right: 2px;
}

.selectAll {
  margin-right: 2px;
}
.description-text {
  display: flex;
  justify-content: center;
}
.description-text p {
  width: 90%;
  text-align: center;
}

img {
  height: 230px;
  width: auto;
  padding: 40px;
}

.content_load {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.reload {
  margin-top: -2vh;
}
</style>